module.exports = __webpack_public_path__ + "static/media/9.e39a2e13.JPG";